import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { RestService } from 'src/app/services/rest-service';
import { AppSettings } from 'src/app/shared/app-settings';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-sites',
  templateUrl: './sites.component.html',
  styleUrls: ['./sites.component.scss'],
  standalone: false
})
export class SitesComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  rows: any;
  displayedColumns: string[] = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  public allSiteData:any = [];
  public urlData: any;
  public filteredSiteData: any = [];
  p: number = 0;
  total: number;
  ipP: number;
  booleanValue: any = false;
  totalPages: number;
  size: number;
  siteFilter: any = '';
  searchFilter: any = '';
  siteType: any = '';
  resolutionType: any = '';
  currentuser: any;
  username: string;
  readOnlyUser: boolean = false;
  sorted: boolean = false;
  loading: boolean = true;
  csvPath='';
  searchurlSites: string;
  searchurlSites2: string;
  searchurlSitesfilter: string;
  searchurlSitescsv: string;
  cstTimeZone = new Date().toLocaleString("en-US",{ timeZone: "America/Chicago",hour12: false});
  loadingUserMessage:string="Loading ...";
  isPageError: boolean=true;
  pageLoadMessage: string = "Loading ...";
  isDropdownSelected: boolean = false;
  private debounceTimeMs = 1000;
  private searchTimer: any;
  searchTerm: string = '';
  dropdownVisible = false;
  columnVisibility: any = {};
  selectAll: boolean;

  constructor(
    private titleService: Title,
    public spinner: SpinnerService,
    private toastr: ToastrService,
    public restService: RestService,
    private router: Router,
    public authService: AuthenticationService,
    private activatedroute: ActivatedRoute,
  ) {
    this.titleService.setTitle("Sites");
      this.csvPath = AppSettings.API_ENDPOINT + AppSettings.SITES_CSV;
   }
   
  ngOnInit(): void {

    try {
      this.searchFilter = this.activatedroute.snapshot.paramMap.get('id');
    } catch (e) {}

    this.getSites();
    this.loadColumnVisibility();
    this.getGrafanaUrls();
    this.selectAll = this.areAllColumnsSelected();
    if (localStorage.getItem('selectAllState-sites') !== JSON.stringify(this.selectAll)) {
      localStorage.setItem('selectAllState-sites', JSON.stringify(this.selectAll));
    }
    let title = this.titleService.getTitle();
  }

  loadColumnVisibility() {
    const savedColumnVisibility = localStorage.getItem('sitesColumnVisibility');
    if (savedColumnVisibility) {
      this.columnVisibility = JSON.parse(savedColumnVisibility);
    } else {
      this.columnVisibility = {
        'Onboarded Date': true,
        'Site Info': true,
        'Site IP': true,
        'Interval': true,
        'Status': true,
        'Installed Status': true,
        'Message': true,
        'Status Duration': true,
        'Time Stamp': true,
        'Opp.Installed Date': true,
        'Opportunity Stage' :true
      };
    }

    const restrictedColumns = ['Potential ID','Customer','Location','Site Unit ID'];
    restrictedColumns.forEach(column => {
    this.columnVisibility[column] = true;
  });
  }

  toggleColumn(columnName: string) {
    this.columnVisibility[columnName] = !this.columnVisibility[columnName];
    this.saveColumnVisibility();
  }

  toggleDropdown() {
    this.dropdownVisible = !this.dropdownVisible;
  }

  getColumnVisibilityKeys() {
    return Object.keys(this.columnVisibility);
  }

  isColumnRestricted(column: string): boolean {
    const restrictedColumns = ['Potential ID','Customer','Location','Site Unit ID'];
    return restrictedColumns.includes(column);
  }


  updateColumnVisibility(selectedColumns: string[]) {
    for (const column in this.columnVisibility) {
      if (this.columnVisibility.hasOwnProperty(column)) {
        this.columnVisibility[column] = false;
      }
    }

    selectedColumns.forEach(column => {
      this.columnVisibility[column] = true;
    });

    this.dropdownVisible = false;
    this.saveColumnVisibility();  
  }

    onColumnVisibilityChange(column: string) {
      this.selectAll = this.areAllColumnsSelected();
      localStorage.setItem('selectAllState-sites', JSON.stringify(this.selectAll));
      this.saveColumnVisibility();
      this.selectAll = Object.keys(this.columnVisibility).every(column => {
        return this.columnVisibility[column] || this.isColumnRestricted(column);
      });
    }

    areAllColumnsSelected(): boolean {
      const allSelected = Object.keys(this.columnVisibility).every((column) => {
        return this.columnVisibility[column] || this.isColumnRestricted(column);
      });
      
      return allSelected;
    }

    saveColumnVisibility() {
      localStorage.setItem('sitesColumnVisibility', JSON.stringify(this.columnVisibility));
      this.selectAll = this.areAllColumnsSelected();
    }

    loadSelectAllState(): void {
      const savedSelectAllState = localStorage.getItem('selectAllState-sites');
      if (savedSelectAllState !== null) {
        this.selectAll = JSON.parse(savedSelectAllState);
      } else {
        this.selectAll = this.areAllColumnsVisible();
      }
    }

    areAllColumnsVisible(): boolean {
      return Object.values(this.columnVisibility).every(visibility => visibility);
    }   

  getGrafanaUrls() {
    this.spinner.activate();
    this.loading = true;
    this.restService.getRequest(AppSettings.GRAFANAURLS, '').subscribe((response) => {
      if(response.hasOwnProperty('data') && response.data !== null){
      this.urlData = response.data;
      this.loading = false;
      } else {
        this.toastr.error('Grafana data not found');
      }
    }, (err) => {
      this.spinner.deactivate();
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error('Session Expired Please login again.', 'Error');
      }
    });
  }

  getSites() {
    this.spinner.activate();
    this.loading = true;
    this.restService.getRequest(AppSettings.DASHBOARDSITES, '').subscribe((response) => {
      if(response ==null || response?.data == null || response?.data?.content == null){
        this.isPageError=true;
        this.loadingUserMessage = "No data found";
      }else{
        this.isPageError=false;
        this.pageLoadMessage= "";
      }

      if(response?.hasOwnProperty('data') && response?.data !== null && response?.data !== undefined && response?.data?.content?.length > 0){
      this.allSiteData = response?.data?.content;
      this.filteredSiteData = response?.data?.content;
      this.total = response?.data?.totalElements;
      this.p = response?.data?.number + 1;
      this.ipP = parseInt(response?.data?.size);
      this.totalPages = response?.data?.totalPages;
      this.size = parseInt(response?.data?.numberOfElements);
      this.spinner.deactivate();
      this.loading = false;
      if (
        this.searchFilter != '' &&
        this.searchFilter != null &&
        this.searchFilter != undefined
      ) {
        this.applyFilter(this.searchFilter);
      }

      } else {
        this.spinner.deactivate();
        this.loading = false;
      if(response?.data?.content?.length == 0){
        this.loadingUserMessage = "No data found";
        this.toastr.error('Sites data not found');
        }
      }
    }, (err) => {
      this.spinner.deactivate();
      this.loading = false;
      this.loadingUserMessage = "No data found";
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error('Session Expired Please login again.', 'Error');
      }
    });
  }

  filterSites() {
    if (!this.searchTerm) {
        this.filteredSiteData = this.allSiteData;
    } else {
        this.filteredSiteData = this.allSiteData.filter(site => 
            site.toLowerCase().includes(this.searchTerm.toLowerCase())
        );
    }
}

  /**
   * getNewItems
   */
   public getNewItems(p) {
    let page = p - 1;
    this.allSiteData = [];
    this.filteredSiteData = [];
    this.total = null;
    this.spinner.activate();
    this.loading = true;
    this.searchFilter = (this.searchFilter)?this.searchFilter:'';
    let url = `dashboard/sites/details?siteType=${this.siteType}&search=${this.searchFilter}&status=${this.siteFilter}&page=${page}&sort=`;
    if (url) {
      this.filterData(url);
    }
  }

  applyFilter(event: Event) {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
    this.isDropdownSelected = true;
    this.loadingUserMessage ="Loading ..."
    this.allSiteData = [];
    this.filteredSiteData = [];
    this.total = null;
    let page = 0;
    this.searchFilter = (this.searchFilter) ? this.searchFilter : '';

    this.searchurlSites = `dashboard/sites/details?siteType=${this.siteType}&search=${this.searchFilter}&status=${this.siteFilter}&page=${page}&sort=`;
    this.searchurlSites2 = `dashboard/sites/export?siteType=${this.siteType}&search=${this.searchFilter}&status=${this.siteFilter}`;

    if (this.searchurlSites2) {
      // this.filterData(this.searchurlSites2);
      this.filterData(this.searchurlSites);
      this.csvPath = AppSettings.API_ENDPOINT + '/'+ this.searchurlSites2;
    }
    this.filterSites();
  },this.debounceTimeMs);
  }

  sortItems(colName, boolean) {
    let sortOrder = (this.sorted == true) ? 'ASC' : 'DESC';
    this.sorted = (this.sorted == false) ? true : false;
    this.loadingUserMessage = 'Loading...';
    this.spinner.activate();
    this.allSiteData = [];
    this.filteredSiteData = [];
    this.total = null;
    let page = this.p - 1;
    this.searchFilter = (this.searchFilter)?this.searchFilter:'';
    let url = `dashboard/sites/details?siteType=${this.siteType}&search=${this.searchFilter}&status=${this.siteFilter}&page=${page}&sort=${colName},${sortOrder}`;
    if (url) {
      this.filterData(url);
    }
  }

  formatDate(dateString) {
    const dateParts = dateString.split('-');
    const formattedDate = `${dateParts[1]}-${dateParts[2]}-${dateParts[0]}`;
    return formattedDate;
  }

  private filterData(url: string) {
    this.spinner.activate();
    this.loading = true;
    this.restService.getSites(url).subscribe((response) => {
      if(response.hasOwnProperty('data') && response.data !== null && response?.data !== undefined && response?.data?.content?.length > 0){
      this.allSiteData = response?.data?.content;
      this.filteredSiteData = response?.data?.content;
      this.p = response?.data?.number + 1;
      this.total = response?.data?.totalElements;
      this.size = parseInt(response?.data?.numberOfElements);
      this.spinner.deactivate();
      this.loading = false;
      } else {
        this.allSiteData = [];
        this.filteredSiteData = [];
        this.total = null;
        this.loadingUserMessage = 'No data found';
        this.spinner.deactivate();
        this.loading = false;
        if(response?.data?.content?.length == 0){
        this.loadingUserMessage = "No data found";
        }
      }
    }, (err) => {
      this.allSiteData = [];
      this.filteredSiteData = [];
      this.total = null;
      this.spinner.deactivate();
      this.loading = false;
      this.loadingUserMessage = "No data found";
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        
      }
    });
  }

  toggleAllColumns(selectAll: boolean): void {
    Object.keys(this.columnVisibility).forEach(column => {
      if (!this.isColumnRestricted(column)) {
        this.columnVisibility[column] = selectAll;
      }
    });
    this.saveColumnVisibility();
    localStorage.setItem('selectAllState-sites', JSON.stringify(this.selectAll));
  }

  formatStageDate(inputDate) {
    if (inputDate !== '-') {
      const dateObj = new Date(inputDate);
      if (!isNaN(dateObj.getTime())) {
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${month}-${day}-${year}`;
      }
    }
    return 'N/A';
  }

  openDashboard(site) {
    this.restService.setSelectedSiteObj(site,this.urlData);
    this.router.navigateByUrl('/sites/details/'+`${site.potentialId}`, { state: { site: site, grafana: this.urlData } });
  }

}
